var _path, _path2, _rect, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFoundTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 411 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.9368 148.031V117.585H5.21094V95.6309L67.552 1.39453H97.3762V96.2523H117.88V117.585H97.3762V148.031H72.9368ZM72.9368 96.2523V30.5975H72.5227L30.893 96.2523H72.9368Z",
    fill: "#73D1F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M355.803 148.031V117.585H288.078V95.6309L350.418 1.39453H380.243V96.2523H400.748V117.585H380.243V148.031H355.803ZM355.803 96.2523V30.5975H355.389L313.76 96.2523H355.803Z",
    fill: "#73D1F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    width: 150,
    height: 150,
    rx: 75,
    fill: "#73D1F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.108 114H248L205.706 24H191.306V24.6909C195.621 27.3991 195.931 31.1461 193.33 37.4501L158 114H167.759L179.553 87.0393H222.146L234.108 114ZM182.546 79.823L200.525 38.8104L218.78 79.823H182.546Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M219 30.6667C219 34.3429 221.99 37.3333 225.667 37.3333C229.381 37.3333 232.333 34.3429 232.333 30.6667C232.333 26.9905 229.381 24 225.667 24C221.99 24 219 26.9905 219 30.6667ZM220.524 30.6667C220.524 27.7333 222.829 25.3333 225.667 25.3333C228.524 25.3333 230.79 27.7143 230.79 30.6667C230.79 33.619 228.524 36 225.667 36C222.829 36 220.524 33.6 220.524 30.6667ZM223.229 33.9429H224.752V31.3524H225.19C226.581 31.3524 226.638 31.9048 226.657 32.419C226.695 33.4476 226.638 33.619 226.905 33.9429H228.467C228.2 33.581 228.257 33.3905 228.2 32.3619C228.162 31.7333 228.105 30.9524 227.248 30.781V30.7429C228.276 30.419 228.371 29.6381 228.371 29.219C228.371 28.8 228.371 27.2762 226.143 27.2762H223.229V33.9429ZM224.752 28.4571H225.762C225.99 28.4571 226.829 28.4762 226.829 29.3143C226.829 29.7143 226.638 30.1714 225.895 30.1714H224.752V28.4571Z",
    fill: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundTitle);
export default __webpack_public_path__ + "static/media/not-found-title.56b355fe0bde870401b390cc606a9e03.svg";
export { ForwardRef as ReactComponent };